import React, { useEffect, useState } from "react";
import { GoogleMap, OverlayView, useJsApiLoader, Marker } from "@react-google-maps/api";

import { categoryMap } from "./data";

export const NeighborhoodMapView = ({ data }) => {
  const [selectedCategory, setSelectedCategory] = useState(data[0].category);
  const [places, setPlaces] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [center, setCenter] = useState({ lat: 39.7217, lng: -104.9703 });

  const { isLoaded } = useJsApiLoader({
    id: "AIzaSyCRJ7Dj5A9n2-mI_CgjsB1gxslSzJb1I3k",
    googleMapsApiKey: "AIzaSyCRJ7Dj5A9n2-mI_CgjsB1gxslSzJb1I3k",
  });

  const handleTabClick = (category, items) => {
    setSelectedCategory(category);
    setPlaces(items);
  };

  const containerStyle = {
    height: "360px",
    width: "100%",
  };

  useEffect(() => {
    if (data.length > 0) {
      setPlaces(data[0]?.items);
    }
  }, []);

  useEffect(() => {
    if (places.length > 0 && places[0].lat_lng) {
      const [lat, lng] = places[0].lat_lng.split(",").map((coord) => parseFloat(coord));

      setCenter({
        lat: lat || "",
        lng: lng || "",
      });
    }
  }, [places]);

  return (
    <div className="hayley-w-full hayley-max-w-[725px] hayley-rounded-[10px]" style={{ border: "1px solid #EEEEEE" }}>
      {isLoaded && (
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
          {/* Add markers */}
          {places.map((place, index) => {
            const [lat, lng] = place.lat_lng.split(",").map((coord) => parseFloat(coord));

            return (
              <div key={index}>
                <Marker position={{ lat: lat, lng: lng }} onMouseOver={() => setSelectedMarker(index)} onMouseOut={() => setSelectedMarker(null)} />

                {selectedMarker === index && (
                  <OverlayView position={{ lat: lat, lng: lng }} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                    <div
                      style={{
                        backgroundColor: "white",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        boxShadow: "0px 9px 12px 0px #9999991F",

                        marginLeft: "14px",
                        marginTop: "-36px",
                        width: "180px",
                        maxWidth: "180px",
                        wordWrap: "break-word",
                        textAlign: "left",
                        transform: "translateY(-100%)",
                      }}
                    >
                      <h2 className="hayley-m-0 hayley-mb-[4px] hayley-text-[12px] hayley-font-normal hayley-text-[#333333]">{place.name}</h2>
                      <p className="hayley-m-0 hayley-text-[11px] hayley-text-[#666666] ">{place?.distance}</p>
                    </div>
                  </OverlayView>
                )}
              </div>
            );
          })}
        </GoogleMap>
      )}

      <div className="hayley-w-full hayley-max-w-[725px] hayley-overflow-x-auto">
        <div className="hayley-flex hayley-w-full">
          {data.map((categoryData, index) => (
            <button
              key={index}
              className={`hayley-focus:outline-none ${
                index === 0 && data.length <= 4 ? "hayley-rounded-bl-[10px]" : ""
              } hayley-w-fit hayley-flex-shrink-0 hayley-cursor-pointer hayley-whitespace-nowrap 
                hayley-border-none hayley-p-[14px] hayley-outline-none ${
                  selectedCategory === categoryData.category
                    ? "hayley-bg-[#F9F9F9] hayley-font-semibold hayley-text-[#333333]"
                    : "hayley-bg-white hayley-text-[#666666]"
                }`}
              onClick={() => handleTabClick(categoryData.category, categoryData?.items)}
            >
              {categoryMap[categoryData?.category] || categoryData?.category}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
